export const Segment = {
  init: () =>
    process.env.NODE_ENV === 'production' &&
    window?.analytics.load('5Zf4fd8rgPb4BvtELCxxnAJgY0j3aRdP'),
  identify: (userId: string, details: any) => window.analytics.identify(userId, details),
  page: () => window.analytics.page(),
  track: (event: string, metadata: { [key: string]: string }) =>
    window.analytics.track(event, metadata),
};
